import { z } from 'zod';

import { IPersonHasDocumentSchema } from './IPersonHasDocument';
import { documentSchema } from './IDocument';
import { realEstateSchema } from './IRealEstate';
import { personSchema } from './IPerson';
import { companySchema } from './ICompany';
import { contactFullObjectSchema } from './IContact';
import { searchRealEstate } from '../components/public/Dialog/PurchaseContract/Components/RealEstate/RealEstateEdit';

export const MortgageDocumentSchema = documentSchema.extend({
  DocumentPurpose: z.string().optional(),
});

export const IMortgageSchema = z.object({
  idPerson: z.number(),
  idMortgage: z.number(),
  idLegalTransaction: z.number(),
  RealEstate: realEstateSchema,
  ToBeDeleted: z.boolean().nullable(),
  MortgageInterest: z.number(),
  AmountMortgage: z.number(),
  BeneficiaryType: z.string(),
  BeneficiaryDetails: z.union([personSchema, companySchema, z.null()]),
  PropertyForBuying: z.boolean().nullable(),
  PropertyOwned: z.boolean().nullable(),
  RealEstateLandRegistryData: z.string(),
  DocumentIndexNumber: z.string().optional(),
  OperationNumber: z.string().optional(),
  Paragraph: z.boolean().nullable(),
  Transcripts: z.array(z.string()),
  id: z.number().nullable(),
  Remarks: z.string(),
  AdditionalServices: z.string(),
  DocumentArray: z.array(MortgageDocumentSchema),
});

export const IMortgageFullObjectSchema = IMortgageSchema.extend({
  PersonArray: z.array(personSchema),
  PersonHasDocument: z.array(IPersonHasDocumentSchema),
  Document: documentSchema.optional(),
  ContactObject: contactFullObjectSchema.optional(),
});

export type MortgageDocument = z.infer<typeof MortgageDocumentSchema>;
export type IMortgage = z.infer<typeof IMortgageSchema>;
export type IMortgageFullObject = z.infer<typeof IMortgageFullObjectSchema>;

export const getEmptyIMortgage: IMortgage = {
  idPerson: 0,
  idMortgage: 0,
  idLegalTransaction: 0,
  RealEstate: searchRealEstate(-1, [], true),
  ToBeDeleted: null,
  MortgageInterest: 0,
  AmountMortgage: 0,
  BeneficiaryType: '',
  BeneficiaryDetails: null,
  PropertyForBuying: null,
  PropertyOwned: null,
  RealEstateLandRegistryData: '',
  DocumentIndexNumber: undefined,
  OperationNumber: undefined,
  Paragraph: null,
  Transcripts: [],
  id: null,
  Remarks: '',
  AdditionalServices: '',
  DocumentArray: [],
};
